/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import PropTypes from "prop-types";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import VerticalPointsIcon from "../../../Common/components/Icons/VerticalPoints/VerticalPointsIcon";
import SearchBar from "../../../Common/components/Inputs/SearchBar/SearchBar";
import t from "../../../Common/utils/translation/translator";
import "./drag-drop-columns.scss";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const getItemStyle = (index, isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: "6px 0 6px 10px",
  // change background colour if dragging
  background: isDragging ? "#f8f8f8" : "#ffffff",
  boxShadow: isDragging ? "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)" : "none",
  borderTop: index !== 0 || isDragging ? "none" : "solid 2px #e3e3e3",
  borderLeft: isDragging ? "none" : "solid 2px #e3e3e3",
  borderRight: isDragging ? "none" : "solid 2px #e3e3e3",
  borderBottom: isDragging ? "none" : "solid 2px #e3e3e3",

  // styles we need to apply on draggables
  ...draggableStyle
});
const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "#eee" : "#ffffff",
  border: isDraggingOver ? "solid 2px #62b3e1" : "solid 2px #fff",
  boxSizing: "border-box",
  width: "100%"
});

/**
 * Returns a sub-list of choosableColumns containing only the objects that are not in columns
 */
function getChoosableColumns(choosableColumns, columns) {
  return choosableColumns.filter((column) => !columns.flat().includes(column));
}

const DragDropColumns = ({ choosableColumns, columns, fullColumns, colKeyToName, updateSelectedColumns }) => {
  const groupsNames = fullColumns.map((group) => group.groupName);
  /**
   * [[not chosen columns], [group 1], [group 2], ...]
   */
  const [state, setState] = useState([getChoosableColumns([...choosableColumns], [...columns]), ...columns]);

  const [searchColumn, setSearchColumn] = useState("");

  /**
   * Moves an item from one list to another list.
   */
  function move(source, destination, droppableSource, droppableDestination) {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    // Removes the item at droppableSource.index in sourceClone
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    // Adds "removed" at droppableDestination.index in destClone
    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
  }

  const onDragEnd = (result) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }
    const sInd = +source.droppableId;
    const dInd = +destination.droppableId;
    if (source.droppableId === "0") {
      source.index = state[0].indexOf(
        state[0].filter((item) => item.toLowerCase().includes(searchColumn.toLowerCase()))[source.index]
      );
    }

    if (sInd === dInd) {
      const items = reorder(state[sInd], source.index, destination.index);
      state[sInd] = items;
      setState(state);
    } else {
      const result2 = move(state[sInd], state[dInd], source, destination);
      state[sInd] = result2[sInd];
      state[dInd] = result2[dInd];
      setState(state);
    }
    updateSelectedColumns(state.slice(1));
  };

  // object of booleans
  const [deployedElements, setDeployedElements] = useState(
    groupsNames.reduce((acc, groupName) => {
      // if it's "Bundle" then false else true
      acc[groupName] = groupName !== "bundle";
      return acc;
    }, {})
  );

  // useEffect(() => {
  //   console.log(deployedElements);
  // }, [deployedElements]);

  return (
    <div style={{ display: "flex" }}>
      <DragDropContext onDragEnd={onDragEnd}>
        <div className="available-columns space-y-2">
          <div>
            <span>{t("msizer.ui.popup.customization.available_columns")}</span>
          </div>
          <SearchBar
            placeholder={t("msizer.ui.popup.customization.search_placeholder")}
            typeAction={(event) => {
              setSearchColumn(event.target.value);
            }}
          />
          {state.slice(0, 1).map((group, ind) => (
            <Droppable key={ind} droppableId={`${ind}`}>
              {(provided, snapshot) => (
                <div ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)} {...provided.droppableProps}>
                  {group
                    /* TODO: check using the traduction */
                    .filter((item) => item.toLowerCase().includes(searchColumn.toLowerCase()))
                    .map((item, index) => (
                      <Draggable key={item} draggableId={item} index={index}>
                        {(provided2, snapshot2) => (
                          <div
                            ref={provided2.innerRef}
                            {...provided2.draggableProps}
                            {...provided2.dragHandleProps}
                            style={getItemStyle(index, snapshot2.isDragging, provided2.draggableProps.style)}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                              }}
                            >
                              <div>{t(colKeyToName(item))}</div>
                              <div style={{ display: "flex" }}>
                                <VerticalPointsIcon color="#aaa" style={{ margin: "0 -12px" }} />
                                <VerticalPointsIcon color="#aaa" style={{ margin: "0" }} />
                              </div>
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          ))}
        </div>

        <div className="displayed-columns">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <span>{t("msizer.ui.popup.customization.displayed_columns")}</span>
          </div>

          <div>
            {state.slice(1).map((group, ind) => (
              <Droppable key={ind + 1} droppableId={`${ind + 1}`} isDropDisabled={groupsNames[ind] === "bundle"}>
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                    {...provided.droppableProps}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center"
                      }}
                    >
                      <div
                        style={{
                          margin: "8px 6px 6px 0",
                          width: "100%"
                        }}
                        className="font-semibold text-sm capitalize flex items-center space-x-2 cursor-pointer select-none"
                        onClick={() => {
                          deployedElements[groupsNames[ind]] = !deployedElements[groupsNames[ind]];
                          setDeployedElements({ ...deployedElements });
                        }}
                      >
                        <span className="text-xs">
                          {deployedElements[groupsNames[ind]] ? <BsChevronUp /> : <BsChevronDown />}
                        </span>
                        <span>{t(`msizer.ui.${groupsNames[ind]}`)}</span>
                      </div>
                    </div>
                    <div className={` ${deployedElements[groupsNames[ind]] ? "" : "hidden"}`}>
                      {group.map((item, index) => (
                        <div className={groupsNames[ind] === "bundle" ? "cursor-not-allowed opacity-50" : ""}>
                          <Draggable
                            isDragDisabled={groupsNames[ind] === "bundle"}
                            className="draggable"
                            key={item}
                            draggableId={item}
                            index={index}
                          >
                            {(provided2, snapshot2) => (
                              <div
                                ref={provided2.innerRef}
                                {...provided2.draggableProps}
                                {...provided2.dragHandleProps}
                                style={getItemStyle(index, snapshot2.isDragging, provided2.draggableProps.style)}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                  }}
                                >
                                  <div>{t(colKeyToName(item)) || item}</div>
                                  <div style={{ display: "flex" }}>
                                    <VerticalPointsIcon color="#aaa" style={{ margin: "0 -12px" }} />
                                    <VerticalPointsIcon color="#aaa" style={{ margin: "0" }} />
                                  </div>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        </div>
                      ))}
                    </div>
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            ))}
          </div>
        </div>
      </DragDropContext>
    </div>
  );
};

DragDropColumns.propTypes = {
  colKeyToName: PropTypes.func,
  updateSelectedColumns: PropTypes.func,
  columns: PropTypes.arrayOf(PropTypes.any),
  fullColumns: PropTypes.arrayOf(PropTypes.any),
  choosableColumns: PropTypes.arrayOf(PropTypes.any)
};

DragDropColumns.defaultProps = {
  columns: [],
  fullColumns: [],
  choosableColumns: [],
  colKeyToName: () => {},
  updateSelectedColumns: () => {}
};

export default DragDropColumns;
